import { Container, injectable } from 'inversify';

export const container = new Container({ defaultScope: 'Singleton' });

export const bind = (type) => (target) => {
  container.bind(type).to(injectable()(target));
};
